import '../css/Team.css';
import { Link } from 'react-router-dom';

const Team = (props) => {
    const slug = props.name.toLowerCase().replace(/ /g, "-");
    const teamPath = props.to || `/teams/premier-league/${slug}`;

    return (
        <Link to={teamPath} id="team-container">
            <img id="team-img" src={props.img} alt={props.name} />
            <p>{props.name}</p>
        </Link>
    );
};

export default Team;